export default __webpack_public_path__ + "static/media/certo.c622b69c.svg";